import React, { useLayoutEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { API_URL } from '../config';

/**
 * Many deployments serve the React app for every path on the customer hostname. Unauthenticated
 * quotation links under /public/quotation/... then hit RequireAuth and redirect to /login.
 * Django serves the real pages under /api/public/quotation/... (same /api prefix as the REST API).
 * This component performs a full-page navigation to the API path so the customer sees the Django UI.
 */
const PublicQuotationApiRedirect = () => {
    const { token } = useParams();
    const location = useLocation();

    useLayoutEffect(() => {
        if (!token) return;
        const origin = API_URL.replace(/\/$/, '');
        const prefix = `/public/quotation/${token}`;
        const after = location.pathname.startsWith(prefix)
            ? location.pathname.slice(prefix.length) || '/'
            : '/';
        const path = `/api/public/quotation/${token}${after === '/' ? '' : after}`;
        const url = `${origin}${path}${location.search}`;
        window.location.replace(url);
    }, [token, location.pathname, location.search]);

    if (!token) {
        return null;
    }

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="100vh"
            gap={2}
        >
            <CircularProgress />
            <Typography variant="body2" color="text.secondary">
                Opening quotation…
            </Typography>
        </Box>
    );
};

export default PublicQuotationApiRedirect;
